import React from "react"
import { useTranslation } from "react-i18next"

import { SelectProps } from "shared/ui/input/select/SelectProps"
import { Select } from "shared/ui/input/select/select/Select"

import { useProjectSortOptions } from "entities/projects/model/useProjectSortOptions"

export const ProjectSortInput = React.memo(
  (props: Partial<SelectProps<string>>) => {
    const { t } = useTranslation()
    const options = useProjectSortOptions()

    return (
      <Select.Root
        name="sort"
        label={t("Sort.SortBy")}
        data-testid="project-sort"
        {...props}
        elevated
      >
        <Select.Label />
        <Select.Input options={props.options ?? options} openMode="dropdown" />
      </Select.Root>
    )
  }
)
